// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Link } from '@riseart/common';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';
import { ArtistActionSection } from 'shared_components/artist/sections/action/Section';

type Props = {
  hideBorder: boolean,
  background?: string | null,
};

/**
 * ArtistBrowseArtSection
 *
 * @param {Props} props
 * @returns {Node}
 */
export function ArtistBrowseArtSection({ hideBorder, background }: Props): Node {
  return (
    <ArtistActionSection
      background={background}
      hideBorder={hideBorder}
      disableHeadingTags
      title={
        <FormattedMessage id="components.artist.findArtTitle">
          {(title: string) => title}
        </FormattedMessage>
      }
      subtitle={
        <FormattedMessage
          id="components.artist.findArtSubtitle"
          values={{
            link: (
              <FormattedMessage id="components.artist.findArtSubtitleLink">
                {(text: string) => (
                  <Link
                    external
                    href={LocalizedConfig.get('externalUrls.talkToCurator')}
                    title={text}
                  >
                    {text}
                  </Link>
                )}
              </FormattedMessage>
            ),
          }}
        />
      }
    >
      <Button type="primary" isAnchor to={UrlAssembler.artList()}>
        <FormattedMessage id="components.artist.findArtAction" />
      </Button>
    </ArtistActionSection>
  );
}
